import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import RfqQuoteDetailCustomerProductList from "@MasterBluePrint/Widgets/RfqQuoteDetail/RfqQuoteDetailCustomerProductList";
import RfqQuoteDetailSalesRepProductList from "@MasterBluePrint/Widgets/RfqQuoteDetail/RfqQuoteDetailSalesRepProductList";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailProductListStyles {}

export const rfqQuoteDetailProductListStyles: RfqQuoteDetailProductListStyles = {};

const styles = rfqQuoteDetailProductListStyles;

const RfqQuoteDetailProductList = ({ quoteState }: Props) => {
    const quote = quoteState.value;
    if (!quote) {
        return null;
    }

    return quote.isSalesperson ? <RfqQuoteDetailSalesRepProductList /> : <RfqQuoteDetailCustomerProductList />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailProductList),
    definition: {
        displayName: "Product List",
        // allowedContexts: ["RfqQuoteDetailsPage"],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
